import { render, staticRenderFns } from "./coperbookingagoraaktarim.vue?vue&type=template&id=81b51944"
import script from "./coperbookingagoraaktarim.vue?vue&type=script&lang=js"
export * from "./coperbookingagoraaktarim.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports